import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M19.5 19V14.65C19.5 13.75 19.1833 12.9833 18.55 12.35C17.9167 11.7167 17.15 11.4 16.25 11.4H5.85L9.7 15.25L8.65 16.3L3 10.65L8.65 5L9.7 6.05L5.85 9.9H16.25C17.55 9.9 18.6667 10.3625 19.6 11.2875C20.5333 12.2125 21 13.3333 21 14.65V19H19.5Z" fill="black"/>
</svg>
;
